import React from 'react';
import PageSeo from '../components/seo/PageSeo';
import { Link, useSearchParams } from 'react-router-dom';
import NewsImage from '../components/NewsImage';
import NewsRowList from '../components/NewsRowList';
import Pagination from '../components/Pagination';
import Subsections from '../subsections/Subsections';
import NewsListSkeleton from '../components/NewsListSkeleton';
import { useCategoryNewsQuery } from '../hooks/useNewsListQuery';
import '../styles/SubsectionContent.css';
import '../App.css';

const FootballUkraine = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const newsPerPage = 25;
  const currentPage = Number(searchParams.get('page')) || 1;
  const neededLimit = currentPage * newsPerPage;
  const {
    news: footballNews,
    initialLoading,
    isRefreshing,
    totalCount,
  } = useCategoryNewsQuery('Футбол України', neededLimit);
  const totalPages = Math.max(1, Math.ceil(totalCount / newsPerPage));

  const handlePageChange = (page) => {
    setSearchParams({ page: String(page) });

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const startIndex = (currentPage - 1) * newsPerPage;
  const pageNews = footballNews.slice(startIndex, startIndex + newsPerPage);

  const heroNews = pageNews[0];
  const restNews = pageNews.slice(1);

  return (
    <div className="home-container panel panel--spaced" aria-busy={isRefreshing}>
      <PageSeo routePath="/football-ukraine" />
      <h1>ФУТБОЛ УКРАЇНИ</h1>

      <Subsections category="Футбол України" />

      <div className="news-content-wrapper">
        {initialLoading && footballNews.length === 0 ? (
          <NewsListSkeleton count={8} />
        ) : (
          <>
          <div className="subsection-news-layout">
            {heroNews && (
              <Link
                to={`/news/${heroNews.id}`}
                className="subsection-hero-news"
              >
                <NewsImage news={heroNews} alt={heroNews.title} loading="eager" />

                <div className="subsection-hero-overlay">
                  <span>
                    {heroNews.day}.{heroNews.month}.{heroNews.year}
                    {heroNews.time ? ` ${heroNews.time}` : ''}
                  </span>

                  <h2>{heroNews.title}</h2>
                </div>
              </Link>
            )}

            <NewsRowList news={restNews} />
          </div>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              disabled={isRefreshing}
              sequential
              pageType="category"
              category="Футбол України"
            />
          )}
          </>
        )}
      </div>
    </div>
  );
};

export default FootballUkraine;
